import React, { useEffect, useState } from 'react'
import { FiDownload, FiRefreshCw } from 'react-icons/fi'
import { Lock, LockOpen } from '@mui/icons-material'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BadgeIcon from '@mui/icons-material/Badge'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import InfoIcon from '@mui/icons-material/Info'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import BlockIcon from '@mui/icons-material/Block'
import VerifiedIcon from '@mui/icons-material/Verified'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import NoAccountsIcon from '@mui/icons-material/NoAccounts'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CheckIcon from '@mui/icons-material/Check'
import PersonIcon from '@mui/icons-material/Person'
import ClearIcon from '@mui/icons-material/Clear'
import Box from '@mui/material/Box'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import dayjs from 'dayjs'
import api, { membershipApi } from '@/services/api'
import AgencyHippaSigningModal from '@/components/consent/AgencyHippaAgreement/AgencyHippaSigningModal'
import Notfound from '../../../Notfound'
import { TableShimmer } from '../../../ShimmerUI'
import PercentIcon from '@mui/icons-material/Percent'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DownloadIcon from '@mui/icons-material/Download'
import VisibilityIcon from '@mui/icons-material/Visibility'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Pagination,
  Tooltip,
  TextField,
  InputAdornment,
  Grid,
  Divider,
  Chip,
  Avatar,
  Card,
  CardContent,
  Typography,
  Alert,
  Stack,
  Paper,
  CircularProgress,
} from '@mui/material'
import RowsPerPageDropdown from '../RowsPerPageDropdown'
import { ProviderDetailsDialog } from '@/components/provider-details'
import TablePopup from './CommonComponent/TablePopup'
import AgencyDetailsDialog from './AgencyDetailsDialog'
const AgencyManagementPage: React.FC = () => {
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(10)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [therapists, setTherapists] = useState([])



  const [error, setError] = useState('')
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [licenseExpiryDate, setLicenseExpiryDate] = useState<Date | null>(null)

  const [totalRecords, setTotalRecords] = useState(0)
  const [filteredRecords, setFilteredRecords] = useState(0)
  const [totalActiveRecords, setTotalActiveRecords] = useState(0)
  const [totalInactiveRecords, setTotalInactiveRecords] = useState(0)
  const [openToggle, setOpenToggle] = useState(false) // Dialog open state
  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [selectedTherapistId, setSelectedTherapistId] = useState<string | null>(
    null
  ) // Selected therapist's ID
  const [isActive, setIsActive] = useState<boolean>(false) // Current status of the therapist
  const [loading, setLoading] = useState<boolean>(false) // Loading state during API request
  const [exportLoading, setExportLoading] = useState<boolean>(false) // Loading state for export
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false) // Commission dialog state
  const [monthlyCommission, setMonthlyCommission] = useState<string>('') // Monthly commission value
  const [yearlyCommission, setYearlyCommission] = useState<string>('') // Yearly commission value
  const [providerFeeDiscountPercent, setProviderFeeDiscountPercent] =
    useState<string>('') // Provider fee discount percentage
  const [commissionLoading, setCommissionLoading] = useState<boolean>(false) // Loading state for commission update
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false) // Verification dialog state
  const [openApproveDialog, setOpenApproveDialog] = useState(false) // Approve dialog state
  const [approveComment, setApproveComment] = useState<string>('') // Approve comment text
  const [selectedProvider, setSelectedProvider] = useState<any>(null) // Selected provider for verification
  const [approveLoading, setApproveLoading] = useState<boolean>(false) // Loading state for approve action
  const [blockLoading, setBlockLoading] = useState<boolean>(false) // Loading state for block action
  const [openBlockReasonDialog, setOpenBlockReasonDialog] = useState(false) // Block reason dialog state
  const [blockReason, setBlockReason] = useState<string>('') // Block reason text
  const [openProviderDetailsDialog, setOpenProviderDetailsDialog] =
    useState(false) // Provider details (read-only) dialog state
  const [selectedProviderForDetails, setSelectedProviderForDetails] =
    useState<any>(null) // Selected provider for details view
  const [openReverifyDialog, setOpenReverifyDialog] = useState(false) // Re-verification dialog state
  const [reverifyProviderId, setReverifyProviderId] = useState<string | null>(
    null
  )
  const [reverifyProviderName, setReverifyProviderName] = useState<string>('')
  const [reverifyLoading, setReverifyLoading] = useState<boolean>(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedProviderForDelete, setSelectedProviderForDelete] =
    useState<any>(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [commissionData, setCommissionData] = useState<any>(null)
  const [enrollmentStatus, setEnrollmentStatus] = useState<string>('')
  const [openTablePopup, setOpenTablePopup] = useState(false)
  const [tableData, setTableData] = useState<any>(null)
  const [tableTitle, setTableTitle] = useState<string>('')

  const [listModalOpen, setListModalOpen] = useState(false)
  const [listModalType, setListModalType] = useState<'provider' | 'user'>('provider')
  const [listModalTitle, setListModalTitle] = useState<string>('')
  const [listModalItems, setListModalItems] = useState<any[]>([])
  const [activeAgencyId, setActiveAgencyId] = useState<string>('')
  const [exportingListCSV, setExportingListCSV] = useState(false)

  const [openHippaSignModal, setOpenHippaSignModal] = useState(false) // Admin HIPAA DocuSign modal state
  const [hippaSignAgencyId, setHippaSignAgencyId] = useState<string | null>(null)
  const [downloadingHippaId, setDownloadingHippaId] = useState<string | null>(null) // Row-level loading state for the download button

  const handleOpenProviderListModal = (therapist: any) => {
    const providers = Array.isArray(therapist?.activeProviderCount)
      ? therapist.activeProviderCount
      : []
    const agencyName = therapist?.agencyName || therapist?.companyName || 'Agency'
    setActiveAgencyId(therapist?._id || therapist?.id || '')
    setListModalTitle(`Number Of Providers (${agencyName})`)
    setListModalType('provider')
    setListModalItems(providers)
    setListModalOpen(true)
  }

  const handleOpenUserListModal = (therapist: any) => {
    const users = Array.isArray(therapist?.activeUserCount)
      ? therapist.activeUserCount
      : []
    const agencyName = therapist?.agencyName || therapist?.companyName || 'Agency'
    setActiveAgencyId(therapist?._id || therapist?.id || '')
    setListModalTitle(`Number of Non-Providers (${agencyName})`)
    setListModalType('user')
    setListModalItems(users)
    setListModalOpen(true)
  }

  const handleExportListCSV = async () => {
    if (!activeAgencyId) return
    const endpoint =
      listModalType === 'provider'
        ? `/admin/agency/${activeAgencyId}/providers/export`
        : `/admin/agency/${activeAgencyId}/users/export`

    try {
      setExportingListCSV(true)
      const response = await api.get(endpoint, {
        responseType: 'blob',
      })

      const contentType = (response.headers as Record<string, any>)['content-type'] || 'text/csv'
      const blob = new Blob([response.data], { type: contentType })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      const contentDisposition = (response.headers as Record<string, any>)['content-disposition']
      let fileName = `agency_${activeAgencyId}_${listModalType}s.csv`
      if (typeof contentDisposition === 'string') {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
        if (fileNameMatch?.[1]) {
          fileName = fileNameMatch[1]
        }
      }

      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error(`Failed to export agency ${listModalType}s:`, error)
    } finally {
      setExportingListCSV(false)
    }
  }
  const handleEnrollmentStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setEnrollmentStatus(e.target.value)
  }
  //finalperclaimfee show only two decimal point
  const finalperclaimfee = Number(monthlyCommission) - Number(providerFeeDiscountPercent);
  const finalperclaimfeeDisplay = finalperclaimfee.toFixed(2);
  const handleExport = async () => {
    setExportLoading(true)
    try {
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      const response = await api.get('admin/agencies/export', {
        responseType: 'blob',
        params,
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: String(response.headers['content-type'] || 'text/csv'),
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      // const contentDisposition = response.headers['content-disposition']
      let filename = 'providers_export.csv'
      // if (contentDisposition) {
      //   const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
      //   if (filenameMatch) {
      //     filename = filenameMatch[1]
      //   }
      // }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error) {
      console.error('Error exporting providers:', error)
      toast.error('Failed to export providers data')
    } finally {
      setExportLoading(false)
    }
  }

  const getFormattedDateForAPI = (date: Date | null): string | null => {
    if (!date) return null

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }

  const handleOpenToggle = (providerId: string, currentStatus: boolean) => {
    setSelectedTherapistId(providerId) // Set the selected therapist to toggle
    setIsActive(currentStatus) // Set the current status of the therapist (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }

  const handleConfirmToggle = async () => {
    if (!selectedTherapistId) return // Exit if no therapist is selected
    setLoading(true) // Start loading

    const newStatus = !isActive // Toggle the status
    try {
      const response = await api.patch(
        `/admin/agency/${selectedTherapistId}/status`,
        { isActive: newStatus }
      )

      if (response.status === 200) {
        setIsActive(newStatus) // Toggle status locally
        toast.success(
          `Agency status updated to ${newStatus ? 'Active' : 'Inactive'}`
        )
      }

      setOpenToggle(false) // Close the dialog after success
      fetchTherapists() // Optionally refresh the therapist list
    } catch (error) {
      console.error('Error updating the provider status:', error)
      toast.error('Failed to update provider status')
    } finally {
      setLoading(false) // Stop loading
    }
  }

  const handleOpenDeleteDialog = (therapist: any) => {
    setSelectedProviderForDelete(therapist)
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => {
    if (!deleteLoading) {
      setOpenDeleteDialog(false)
      setSelectedProviderForDelete(null)
    }
  }

  const handleConfirmDelete = async () => {
    if (!selectedProviderForDelete?._id) return

    setDeleteLoading(true)
    try {
      await api.delete(`admin/agency/${selectedProviderForDelete._id}`)
      toast.success('Agency deleted successfully')
      handleCloseDeleteDialog()
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error deleting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete provider')
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleOpenHippaSignModal = (therapist: any) => {
    setHippaSignAgencyId(therapist?._id || null)
    setOpenHippaSignModal(true)
  }

  const handleHippaSigned = () => {
    setOpenHippaSignModal(false)
    setHippaSignAgencyId(null)
    toast.success('HIPAA agreement signed successfully')
    fetchTherapists(currentPage) // Refresh so the button switches to "Download"
  }

  const handleDownloadHippaAgreement = async (agencyId: string) => {
    if (!agencyId) return
    setDownloadingHippaId(agencyId)
    try {
      const { signedUrl } = await membershipApi.downloadAgencyHippaAgreement(agencyId)
      // NOTE: fetching the S3 signedUrl as a blob (to force a real download)
      // fails with a CORS error — the bucket doesn't return
      // Access-Control-Allow-Origin for this origin. Forcing a "Save As"
      // download needs a backend change (see chat), so for now this just
      // opens the file like the rest of the app does.
      window.open(signedUrl, '_blank', 'noopener,noreferrer')
    } catch (error) {
      console.error('Failed to download HIPAA agreement PDF:', error)
      toast.error('Failed to download HIPAA agreement PDF')
    } finally {
      setDownloadingHippaId(null)
    }
  }

  // const handleOpenCommissionDialog = (therapist: any) => {
  //   setSelectedTherapistId(therapist._id)
  //   setMonthlyCommission(therapist.commission?.toString() || '')
  //   setProviderFeeDiscountPercent(
  //     therapist.providerFeeDiscountPercent?.toString() || ''
  //   )
  //   setCommissionData(therapist)

  //   console.log('commissionData', therapist)
  //   setOpenCommissionDialog(true)
  // }

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false)
    setSelectedTherapistId(null)
    setMonthlyCommission('')
    setYearlyCommission('')
    setProviderFeeDiscountPercent('')
    setCommissionData(null)
  }

  const handleUpdateCommission = async () => {
    if (!selectedTherapistId) return

    // Validate inputs
    if (!monthlyCommission.trim()) {
      toast.error('Please enter both monthly and yearly commission values')
      return
    }
    if (finalperclaimfee <= 0) {
      toast.error('The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.')
      return
    }


    const commission = parseFloat(monthlyCommission)
    const discountValue = providerFeeDiscountPercent.trim()
      ? parseFloat(providerFeeDiscountPercent)
      : 0

    if (
      isNaN(commission) ||
      commission < 0
    ) {
      toast.error('Please enter valid commission values (numbers >= 0)')
      return
    }

    if (
      providerFeeDiscountPercent.trim() &&
      (isNaN(discountValue) || discountValue < 0 || discountValue > 100)
    ) {
      toast.error('Please enter a valid discount percentage (0-100)')
      return
    }

    setCommissionLoading(true)
    try {
      const response = await api.patch(
        `/admin/agency/${selectedTherapistId}/commission`,
        {
          commission: commission,
          providerFeeDiscountPercent: discountValue,
        }
      )

      if (response.status === 200) {
        toast.success('Commission updated successfully')
        handleCloseCommissionDialog()
        fetchTherapists(1) // Refresh the therapist list
        setCurrentPage(1)
      }
    } catch (error: any) {
      console.error('Error updating commission:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update commission'
      )
    } finally {
      setCommissionLoading(false)
    }
  }

  const handleOpenVerificationDialog = (therapist: any) => {
    setSelectedProvider(therapist)
    setOpenVerificationDialog(true)
  }

  const handleCloseVerificationDialog = () => {
    setOpenVerificationDialog(false)
    setSelectedProvider(null)
  }

  const handleOpenProviderDetailsDialog = (therapist: any) => {
    setSelectedProviderForDetails(therapist)
    setOpenProviderDetailsDialog(true)
  }

  const handleCloseProviderDetailsDialog = () => {
    setOpenProviderDetailsDialog(false)
    setSelectedProviderForDetails(null)
  }

  const handleOpenApproveDialog = () => {
    setApproveComment('')
    setOpenApproveDialog(true)
  }

  const handleCloseApproveDialog = () => {
    setOpenApproveDialog(false)
    setApproveComment('')
  }

  const handleApproveTherapist = async () => {
    if (!selectedProvider?._id) return

    setApproveLoading(true)
    try {
      const response = await api.post(
        `/agency/${selectedProvider._id}/approve`,
        {
          approveComment: approveComment.trim(),
        }
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message || 'Agency approved successfully')
        handleCloseApproveDialog()
        handleCloseVerificationDialog()
        fetchTherapists(currentPage) // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    } finally {
      setApproveLoading(false)
    }
  }

  const handleOpenBlockReasonDialog = () => {
    setBlockReason('')
    setOpenBlockReasonDialog(true)
  }

  const handleCloseBlockReasonDialog = () => {
    setOpenBlockReasonDialog(false)
    setBlockReason('')
  }

  const handleConfirmBlock = async () => {
    if (!selectedProvider?._id) return

    if (!blockReason.trim()) {
      toast.error('Please provide a reason for blocking the provider')
      return
    }

    setBlockLoading(true)
    try {
      const response = await api.post(
        `/agency/${selectedProvider._id}/block`,
        {
          reason: blockReason.trim(),
        }
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseBlockReasonDialog()
        handleCloseVerificationDialog()
        fetchTherapists(currentPage) // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error blocking provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to block provider')
    } finally {
      setBlockLoading(false)
    }
  }

  // const handleOpenReverifyDialog = (therapist: any) => {
  //   setReverifyProviderId(therapist?._id || null)
  //   setReverifyProviderName(
  //     therapist
  //       ? `${therapist?.firstName || ''} ${therapist?.lastName || ''}`.trim()
  //       : ''
  //   )
  //   setOpenReverifyDialog(true)
  // }

  const handleCloseReverifyDialog = () => {
    setOpenReverifyDialog(false)
    setReverifyProviderId(null)
    setReverifyProviderName('')
  }

  const handleReverifyProvider = async () => {
    if (!reverifyProviderId) return

    setReverifyLoading(true)

    try {
      const response = await api.get(
        `/agreements/signed/agency-verification/${reverifyProviderId}`
      )

      const message =
        response?.data?.message ||
        'Agency re-verification request completed successfully'

      toast.success(message)

      // Refresh the therapist list to reflect any potential changes
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error during provider re-verification:', error)

      const message =
        error?.response?.data?.message || 'Failed to re-verify provider'

      toast.error(message)
    } finally {
      setReverifyLoading(false)
      handleCloseReverifyDialog()
    }
  }

  const formatDateMMDDYY = (date: string | Date | null | undefined) => {
    if (!date) return '--'
    const dayjsDate = dayjs(date)
    if (!dayjsDate.isValid()) return '--'
    return dayjsDate.format('MM/DD/YYYY')
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
    fetchTherapists(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }
  const fetchTherapists = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      // const params: Record<string, any> = {
      //   accountStatus:
      //     selectedAccountStatus === 'Active'
      //       ? true
      //       : selectedAccountStatus === 'Inactive'
      //         ? false
      //         : undefined,
      //   page: page || 1, // Default to 1 if page is not provided
      //   limit: pageSize,
      // }
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
        page: page || 1,
        limit: pageSize,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (enrollmentStatus) {
        params.enrollmentStatus = enrollmentStatus
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      // Add sorting parameters
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }

      // Make the API call with params
      const response = await api.get('admin/agencies', {
        params,
      })

      // Check if data exists and set the therapists state
      if (response?.data?.data) {
        setTherapists(response.data.data)
      } else {
        setError('No agencies data found')
      }
      setFilteredRecords(response?.data?.totalRecords ?? response?.data?.stats?.totalAgencys ?? 0)
      setTotalRecords(response?.data?.stats?.totalAgencys)
      setTotalActiveRecords(response?.data?.stats?.totalActiveAgencys)
      setTotalInactiveRecords(response?.data?.stats?.totalInactiveAgencys)
      setTotalPages(Math.ceil(response?.data?.totalRecords / pageSize) || 1)
    } catch (err: any) {
      console.error(err)
      setError('Failed to fetch providers')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }
  const handleReset = () => {
    setSearchKeyword('')
    setSelectedAccountStatus('')
    setStartDate(null)
    setEndDate(null)
    setLicenseExpiryDate(null)
    setSortField('')
    setSortOrder('asc')
    setEnrollmentStatus('')
  }

  const handleSort = (field: string) => {
    if (sortField === field) {
      // Toggle sort order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Set new field and default to ascending
      setSortField(field)
      setSortOrder('asc')
    }
  }

  const getSortIcon = (field: string) => {
    if (sortField !== field) {
      return <UnfoldMoreIcon className="w-4 h-4 ml-1" />
    }
    return sortOrder === 'asc' ? (
      <KeyboardArrowUpIcon className="w-4 h-4 ml-1" />
    ) : (
      <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
    )
  }


  useEffect(() => {

    fetchTherapists(currentPage)
  }, [
    searchKeyword,
    selectedAccountStatus,
    startDate,
    endDate,
    licenseExpiryDate,
    sortField,
    sortOrder,
    pageSize,
    currentPage,
    enrollmentStatus
  ])



  const getLicenseDateColor = (licenseExpiration: string) => {
    if (!licenseExpiration) return 'text-gray-500';

    const [day, month, year] = licenseExpiration.split('/').map(Number);

    const expirationDate = new Date(year, month - 1, day, 23, 59, 59);
    const today = new Date();

    const diffTime = expirationDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Expired
    if (diffDays < 0) {
      return 'text-red-500';
    }

    // Expiring within 30 days
    if (diffDays <= 30) {
      return 'text-yellow-500';
    }

    // Active
    return 'text-green-500';
  };


  // console.log("therapists ----->", therapists)













  return (
    <div className="p-6 mx-auto max-w-7xl">

      <div className="flex flex-col items-start justify-between gap-4 mb-4 sm:flex-row sm:items-center">
        <h1 className="text-2xl font-semibold text-[#6E7B8B]">
          Agency Management
        </h1>
        <button
          className="flex items-center gap-2 px-4 py-2 text-white bg-[#5BC0BE] border border-gray-300 rounded-lg hover:bg-[#49a9a7] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleExport}
          disabled={exportLoading}
          style={{
            cursor: exportLoading ? 'not-allowed' : 'pointer',
          }}
        >
          <FiDownload className="w-4 h-4" />
          {exportLoading ? 'Exporting...' : 'Export CSV'}
        </button>
      </div>

      <Card
        sx={{
          height: '100%',
          cursor: 'pointer',
          boxShadow: 2,
          padding: 2,
          mb: 3,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        <CardContent>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-6">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Search Agency
              </label>
              <input
                type="text"
                value={searchKeyword}
                onChange={e => {
                  setSearchKeyword(e.target.value)
                  setCurrentPage(1)
                }}
                placeholder="Search agency"
                className="w-full border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Account Status
              </label>
              <select
                id="accountStatus"
                value={selectedAccountStatus}
                onChange={handleAccountStatusChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              >
                <option value="" disabled selected>
                  Select Status
                </option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            {/* <Box>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Enrollment Status
              </label>
              <select
                id="accountStatus"
                value={enrollmentStatus}
                onChange={handleEnrollmentStatusChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              >
                <option value="" disabled selected>
                  Select Status
                </option>
                <option value="true">Enrolled</option>
                <option value="false">Not Enrolled</option>
              </select>
            </Box> */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box display="flex" alignItems="flex-start" gap={2} width="100%">
                <Box>
                  <Typography variant="body2" mb={0.5}>
                    Start Date (Onboard)
                  </Typography>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue: Date | null) => setStartDate(newValue)}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="body2" mb={0.5}>
                    End Date (Onboard)
                  </Typography>
                  <DatePicker
                    value={endDate}
                    onChange={(newValue: Date | null) => setEndDate(newValue)}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="body2" mb={0.5}>
                    License Expiry
                  </Typography>
                  <DatePicker
                    value={licenseExpiryDate}
                    onChange={(newValue: Date | null) =>
                      setLicenseExpiryDate(newValue)
                    }
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>


                {/* Reset All Button */}
                <Box display="flex" alignItems="center">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleReset}
                    sx={{
                      borderRadius: 2,
                      marginTop: '28px',
                    }}
                  >
                    {/* reset icon */}
                    <FiRefreshCw className="w-4 h-4" />
                  </Button>
                </Box>
              </Box>
            </LocalizationProvider>
          </div>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-3">
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow h-35">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{totalRecords}</h2>
            <p className="text-sm text-gray-500">Total Agencies</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-green-600 bg-green-100 rounded-full">
            <PersonIcon />
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {totalActiveRecords}
            </h2>
            <p className="text-sm text-gray-500">Active Accounts</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-blue-600 bg-blue-100 rounded-full">
            <CheckIcon />
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {totalInactiveRecords}
            </h2>
            <p className="text-sm text-gray-500">Inactive Agency</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-red-600 bg-red-100 rounded-full">
            <ClearIcon />
          </div>
        </div>
      </div>

      {/* Active Filters & Selected Details Banner */}
      {(searchKeyword || selectedAccountStatus || startDate || endDate || licenseExpiryDate || enrollmentStatus) && (
        <div className="px-4 py-3 mb-6 bg-[#f0faf9] border border-[#b2e5e3] rounded-lg shadow-sm flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-[#2d6866] text-sm">Active Filters Applied</span>
            <span className="px-2.5 py-0.5 text-xs font-semibold text-white bg-[#5BC0BE] rounded-full">
              {filteredRecords} Found
            </span>
          </div>
          <button
            onClick={handleReset}
            className="text-xs font-medium text-[#3b9391] hover:text-[#2d6866] underline"
          >
            Clear All Filters
          </button>
        </div>
      )}

      {/* Therapist Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('firstName')}
                >
                  <div className="flex items-center">
                    Name
                    {getSortIcon('firstName')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  <div className="flex items-center">
                    Email
                    {getSortIcon('email')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('phone')}
                >
                  <div className="flex items-center">
                    Phone
                    {getSortIcon('phone')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('createdAt')}
                >
                  <div className="flex items-center">
                    Onboarding
                    {getSortIcon('createdAt')}
                  </div>
                </th>
                <th className="px-6 py-3 font-medium">License No</th>
                <th className="px-6 py-3 font-medium">Number Of Providers </th>
                <th className="px-6 py-3 font-medium">Number of Non-Providers</th>
                <th className="px-6 py-3 font-medium">License Expiration</th>
                <th className="px-6 py-3 font-medium">Accepted Insurances</th>
                <th className="px-6 py-3 font-medium">Account Status</th>
                <th className="px-6 py-3 font-medium text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loadingForShimmer ? (
                <TableShimmer columns={11} />
              ) : therapists?.length === 0 ? (
                <tr>
                  <td colSpan={20} className="p-4 text-center">
                    <Notfound />
                  </td>
                </tr>
              ) : (
                therapists.map(therapist => (
                  <tr
                    key={therapist._id}
                    className="transition-colors hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 min-w-[200px]">
                      <div className="flex items-center gap-2">
                        <Tooltip title="View Agency Details" arrow placement="top">
                          <span
                            role="button"
                            tabIndex={0}
                            onClick={() =>
                              handleOpenProviderDetailsDialog(therapist)
                            }
                            onKeyDown={e => {
                              if (e.key === 'Enter' || e.key === ' ')
                                handleOpenProviderDetailsDialog(therapist)
                            }}
                            className="cursor-pointer font-medium text-[#5BC0BE] hover:text-[#4a9d9b] hover:underline focus:outline-none focus:underline"
                          >
                            {therapist?.agencyName}
                          </span>
                        </Tooltip>
                        {therapist?.status?.toLowerCase() === 'active' && (
                          <Tooltip title="Approved" arrow placement="top">
                            <VerifiedIcon
                              sx={{
                                color: '#2e7d32',
                                fontSize: 18,
                                opacity: 0.9,
                              }}
                            />
                          </Tooltip>
                        )}
                        {therapist?.status?.toLowerCase() === 'blocked' && (
                          <Tooltip title="Blocked" arrow placement="top">
                            <NoAccountsIcon
                              sx={{
                                color: '#c62828',
                                fontSize: 18,
                                opacity: 0.9,
                              }}
                            />
                          </Tooltip>
                        )}
                        {therapist?.status?.toLowerCase() !== 'active' &&
                          therapist?.status?.toLowerCase() !== 'blocked' && (
                            <Tooltip title="Not Verified" arrow placement="top">
                              <DoNotDisturbAltIcon
                                sx={{
                                  color: '#9e9e9e',
                                  fontSize: 18,
                                  opacity: 0.8,
                                }}
                              />
                            </Tooltip>
                          )}
                      </div>
                    </td>
                    <td className="px-6 py-4">{therapist?.companyEmail}</td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.companyPhone}
                    </td>


                    <td className="px-6 py-4">
                      {formatDateMMDDYY(therapist?.createdAt) || '--'}
                    </td>
                    <td className="px-6 py-4 min-w-[280px]">
                      {therapist?.licenses && therapist.licenses.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {therapist.licenses
                            .filter((license: any) => license.licenseNumber)
                            .map((license: any, index: number) => (
                              <span
                                key={index}
                                className="px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 border border-blue-200 rounded-full"
                              >
                                {license.licenseNumber}
                              </span>
                            ))}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>

                    <td className="px-6 py-4 min-w-[150px]">
                      {(() => {
                        const count = Array.isArray(therapist?.activeProviderCount)
                          ? therapist.activeProviderCount.length
                          : therapist?.noOfProvider ?? 0
                        return count > 0 ? (
                          <button
                            type="button"
                            onClick={() => handleOpenProviderListModal(therapist)}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-[#e6f7f7] text-[#3a9e9c] border border-[#b2e5e4] hover:bg-[#d0f0ef] transition-all shadow-sm cursor-pointer"
                          >
                            <span>{count}</span>
                            <span className="text-[10px] font-normal text-[#3a9e9c]">(View)</span>
                          </button>
                        ) : (
                          <span className="text-xs font-medium text-gray-500 pl-2">0</span>
                        )
                      })()}
                    </td>
                    <td className="px-6 py-4 min-w-[150px]">
                      {(() => {
                        const count = Array.isArray(therapist?.activeUserCount)
                          ? therapist.activeUserCount.length
                          : therapist?.noOfUser ?? 0
                        return count > 0 ? (
                          <button
                            type="button"
                            onClick={() => handleOpenUserListModal(therapist)}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-[#e6f7f7] text-[#3a9e9c] border border-[#b2e5e4] hover:bg-[#d0f0ef] transition-all shadow-sm cursor-pointer"
                          >
                            <span>{count}</span>
                            <span className="text-[10px] font-normal text-[#3a9e9c]">(View)</span>
                          </button>
                        ) : (
                          <span className="text-xs font-medium text-gray-500 pl-2">0</span>
                        )
                      })()}
                    </td>



                    {/* <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.licenseExpiration ? (
                        <span
                          className={`text-xs font-medium ${getLicenseDateColor(
                            therapist.licenseExpiration
                          )}`}
                        >
                          {therapist.licenseExpiration}
                        </span>
                      ) : (
                        '--'
                      )}
                    </td> */}
                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.licenses && therapist.licenses.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {therapist.licenses
                            .filter((license: any) => license.expiryDate)
                            .map((license: any, index: number) => {
                              const expiryDate = new Date(license.expiryDate);
                              const today = new Date();

                              today.setHours(0, 0, 0, 0);
                              expiryDate.setHours(0, 0, 0, 0);

                              const diffInDays =
                                (expiryDate.getTime() - today.getTime()) /
                                (1000 * 60 * 60 * 24);

                              const isExpired = diffInDays < 0;
                              const isExpiringSoon = diffInDays >= 0 && diffInDays <= 30;

                              return (
                                <span
                                  key={index}
                                  className={`px-2 py-1 text-xs font-medium rounded-full border ${isExpired
                                    ? 'text-red-700 bg-red-100 border-red-200'
                                    : isExpiringSoon
                                      ? 'text-yellow-700 bg-yellow-100 border-yellow-200'
                                      : 'text-green-700 bg-green-100 border-green-200'
                                    }`}
                                >
                                  {license.expiryDate}
                                </span>
                              );
                            })}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>

                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.insuranceAccepted &&
                        therapist.insuranceAccepted.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {therapist.insuranceAccepted
                            .filter((insurance: any) => insurance.name)
                            .map((insurance: any, index: number) => (
                              <span
                                key={index}
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 10px',
                                  fontSize: '0.72rem',
                                  fontWeight: 600,
                                  color: '#1b5e20',
                                  background: '#f1f8f1',
                                  border: '1px solid #c8e6c9',
                                  borderRadius: '6px',
                                  lineHeight: '1.3',
                                  width: 'fit-content',
                                }}
                              >
                                {insurance.name}
                              </span>
                            ))}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>

                    {/* <td>
                      <Chip
                        label={therapist?.enrollmentStatus ? "Enrolled" : "Not Enrolled"}
                        color={therapist?.enrollmentStatus ? "success" : "error"}
                      />
                    </td> */}
                    {/* quiq enrollment button */}
                    {/* <td>

                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setOpenTablePopup(true)
                          setTableTitle('Quick Enroll')
                          setTableData(therapist?.providerInsurance)
                        }}
                      >
                        Quick Enroll
                      </Button>
                    </td> */}
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium border ${therapist?.isActive
                          ? 'border-green-500 text-green-600'
                          : 'border-red-500 text-red-600'
                          }`}
                      >
                        {therapist?.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex items-center justify-center gap-2">
                        <Tooltip title="View Agency Verification" arrow placement="top">
                          <IconButton
                            onClick={() =>
                              handleOpenVerificationDialog(therapist)

                            }
                            size="small"
                            sx={{
                              color: '#5BC0BE',
                              '&:hover': {
                                bgcolor: 'rgba(91, 192, 190, 0.1)',
                              },
                            }}
                          >
                            <VerifiedUserIcon />
                          </IconButton>
                        </Tooltip>

                        <Tooltip
                          title={
                            !therapist?.hasSignedHIPAADocusignAgreement
                              ? 'Agency has not signed the HIPAA agreement yet'
                              : therapist?.hasSignedHIPAADocusignAgreementAdmin
                                ? 'View HIPAA Agreement'
                                : 'Sign HIPAA Agreement'
                          }
                          arrow
                          placement="top"
                        >
                          <span>
                            <IconButton
                              onClick={() =>
                                therapist?.hasSignedHIPAADocusignAgreementAdmin
                                  ? handleDownloadHippaAgreement(therapist?._id)
                                  : handleOpenHippaSignModal(therapist)
                              }
                              disabled={
                                downloadingHippaId === therapist?._id ||
                                !therapist?.hasSignedHIPAADocusignAgreement
                              }
                              size="small"
                              sx={{
                                color: '#6F5FA6',
                                '&:hover': {
                                  bgcolor: 'rgba(111, 95, 166, 0.1)',
                                },
                              }}
                            >
                              {downloadingHippaId === therapist?._id ? (
                                <CircularProgress size={18} sx={{ color: 'inherit' }} />
                              ) : therapist?.hasSignedHIPAADocusignAgreementAdmin ? (
                                <VisibilityIcon sx={{ fontSize: 20 }} />
                              ) : (
                                <HealthAndSafetyIcon sx={{ fontSize: 20 }} />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                        {/* <Tooltip title="Re-Verify Agency" arrow placement="top">
                          <IconButton
                            onClick={() => handleOpenReverifyDialog(therapist)}
                            size="small"
                            sx={{
                              color: '#10b981',
                              '&:hover': {
                                bgcolor: 'rgba(16, 185, 129, 0.1)',
                              },
                            }}
                          >
                            <AutorenewIcon />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title={
                          therapist?.isActive ? 'Deactivate' : 'Activate'
                        }
                          arrow
                          placement="top"
                        >
                          <IconButton
                            onClick={() =>
                              handleOpenToggle(
                                therapist?._id,
                                therapist?.isActive
                              )
                            }
                          >
                            {therapist?.isActive ? (
                              <ToggleOnIcon
                                sx={{ fontSize: 32, color: '#10b981' }}
                              />
                            ) : (
                              <ToggleOffIcon
                                sx={{ fontSize: 32, color: '#ef4444' }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Agency" arrow placement="top">
                          <IconButton
                            onClick={() => handleOpenDeleteDialog(therapist)}
                            size="small"
                            sx={{
                              color: '#dc2626',
                              '&:hover': {
                                bgcolor: 'rgba(220, 38, 38, 0.1)',
                              },
                            }}
                          >
                            <DeleteForeverIcon sx={{ fontSize: 22 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          <RowsPerPageDropdown
            pageSize={pageSize}
            onPageSizeChange={newPageSize => {
              handlePageSizeChange(newPageSize)
              if (ourPageSize && ourPageSize !== newPageSize) {
                setCurrentPage(1)
              }
            }}
          />
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>
      <ToastContainer />
      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          agency?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Provider Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            pt: 2.5,
            px: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: 'error.lighter',
            }}
          >
            <DeleteForeverIcon sx={{ fontSize: 28, color: 'error.main' }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" fontWeight={600}>
              Delete Agency
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              display="block"
              mt={0.5}
            >
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to permanently delete this agency? All
            associated data will be removed.
          </Typography>
          {selectedProviderForDelete && (
            <Box
              sx={{
                p: 2,
                mb: 2,
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Agency name:</strong> {''}
                {selectedProviderForDelete.agencyName}

              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Agency email:</strong> {''}
                {selectedProviderForDelete.companyEmail}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2.5,
            px: 3,
            gap: 1.5,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Button
            onClick={handleCloseDeleteDialog}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={deleteLoading}
            variant="contained"
            color="error"
            startIcon={
              deleteLoading ? null : <DeleteForeverIcon sx={{ fontSize: 18 }} />
            }
          >
            {deleteLoading ? 'Deleting...' : 'Delete Agency'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openReverifyDialog} onClose={handleCloseReverifyDialog}>
        <DialogTitle>Re-Verify Agency</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 1.5 }}>
            Are you sure you want to initiate re-verification for{' '}
            <strong>{reverifyProviderName || 'this Agency'}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReverifyDialog}
            variant="outlined"
            disabled={reverifyLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReverifyProvider}
            color="primary"
            variant="contained"
            disabled={reverifyLoading}
          >
            {reverifyLoading ? 'Re-verifying...' : 'Confirm Re-Verification'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Commission Dialog */}
      <Dialog
        open={openCommissionDialog}
        onClose={handleCloseCommissionDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Per Claim System Fee & Discount</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',

          }}
        >
          {commissionData?.plan_id?.name && (
            <Typography sx={{ pt: 0.5 }}>
              <strong>Subscribed Plan:</strong> {commissionData?.plan_id?.name}
            </Typography>
          )}
          {commissionData?.plan_id?.monthly_fee && commissionData?.plan_id?.anual_fee && (
            <Typography variant="body1" sx={{ mb: 0.2 }}>
              <strong>Subscription Fee:</strong>{" "}
              {commissionData?.frequency === "Month"
                ? `$${commissionData?.plan_id?.monthly_fee}`
                : `$${commissionData?.plan_id?.anual_fee}`}
            </Typography>
          )}
          {commissionData?.plan_id?.commission && (
            <Typography variant="body1" sx={{ mb: 1.6 }}>
              <strong>Per-Claim System Fee:</strong> {`${commissionData?.plan_id?.commission}%`}
            </Typography>
          )}
          <TextField
            label="Per Claim System Fee"
            type="number"
            value={monthlyCommission}
            sx={{ mb: 1.6, mt: 1.6 }}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : monthlyCommission
                setMonthlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee percentage"
          />
          {/* <TextField
            label="Yearly Commission"
            type="number"
            value={yearlyCommission}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d+(\.\d{0,2})?)?$/)
                  ? inputValue
                  : yearlyCommission
                setYearlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the yearly commission percentage"
          /> */}
          <TextField
            label="Per Claim System Fee Discount"
            type="number"
            value={providerFeeDiscountPercent}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places) between 0-100
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : providerFeeDiscountPercent
                // Check if value is within valid range (0-100)
                if (
                  validValue === '' ||
                  (parseFloat(validValue) >= 0 && parseFloat(validValue) <= 100)
                ) {
                  setProviderFeeDiscountPercent(validValue)
                }
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee Discount (0-100)"
          />

          <Typography variant="body1" sx={{ mb: 1.6, mt: 1.6 }}>
            <strong>Final Per Claim Fee:</strong> {finalperclaimfeeDisplay}%
          </Typography>
          {/* if Final Per Claim Fee less than or equal to 0, show a error message */}
          {finalperclaimfee <= 0 && (
            <Typography variant="body2" color="error">
              The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.
            </Typography>
          )}


        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseCommissionDialog}
            disabled={commissionLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCommission}
            variant="contained"
            color="primary"
            disabled={commissionLoading}
          >
            {commissionLoading ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Verification Dialog */}
      <Dialog
        open={openVerificationDialog}
        onClose={handleCloseVerificationDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
            pt: 3,
            px: 3,
            background: 'linear-gradient(135deg, #5BC0BE 0%, #4a9d9b 100%)',
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <VerifiedUserIcon sx={{ fontSize: 28 }} />
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, letterSpacing: 0.5 }}
              >
                Agency Document Verification
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleCloseVerificationDialog}
            size="small"
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ pt: '1rem !important', pb: 2, px: 3, bgcolor: '#f8f9fa' }}
        >
          {selectedProvider && (
            <>
              <Grid container spacing={3}>






                {/* Agency Documents Section */}
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <BadgeIcon sx={{ color: '#5BC0BE', fontSize: 28 }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Agency Documents
                        </Typography>
                      </Box>

                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        {[
                          { label: 'Legal Business Name ', value: selectedProvider.agencyNameDoc, displayName: selectedProvider.agencyName },
                          { label: 'DBA Name Document', value: selectedProvider.dbaNameDoc, displayName: selectedProvider.dbaName },
                          { label: 'EIN Document', value: selectedProvider.companyEinDoc, displayName: selectedProvider.companyEin || selectedProvider.taxId },
                          { label: 'NPI Certificate', value: selectedProvider.npiCertificate, displayName: selectedProvider.companyNpi || selectedProvider.billingNpi },
                          // { label: 'Company NPI Document', value: selectedProvider.companyNpiDoc, displayName: selectedProvider.companyNpi || selectedProvider.billingNpi },
                          // { label: 'Secretary of State Statement of Information', value: selectedProvider.businessLicense, displayName: selectedProvider.licenseNumber },
                          { label: 'Agency License', value: selectedProvider.agencyLicense },
                          { label: 'NPI Certificate', value: selectedProvider.npiCertificate, displayName: selectedProvider.companyNpi || selectedProvider.billingNpi },
                          { label: 'W-9', value: selectedProvider.wnineForm },
                          // { label: 'Certificate of Insurance', value: selectedProvider.certificateInsurance },
                          { label: 'HIPAA Signed Document', value: selectedProvider.hipaaSignedDocumentUrl },
                        ].map((doc, idx, arr) => {
                          const rawName = doc.value
                            ? decodeURIComponent(doc.value.split('?')[0].split('/').pop() || 'document')
                            : null
                          const fileName = rawName && rawName.length > 40
                            ? rawName.slice(0, 18) + '…' + rawName.slice(-18)
                            : rawName
                          const displayText = doc.displayName || fileName
                          return (
                            <Box
                              key={idx}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                py: 1.5,
                                px: 1,
                                borderBottom: idx < arr.length - 1 ? '1px solid #f0f0f0' : 'none',
                                '&:hover': { bgcolor: '#fafafa', borderRadius: 1 },
                              }}
                            >
                              {/* Label */}
                              <Box sx={{ minWidth: 220, flexShrink: 0 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: '#2c3e50',
                                    fontSize: '0.875rem',
                                  }}
                                >
                                  {doc.label}
                                </Typography>
                              </Box>

                              {/* File name / Name / Number */}
                              <Box sx={{ flex: 1, px: 2 }}>
                                {doc.value ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <Box
                                      component="span"
                                      sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        bgcolor: '#5BC0BE',
                                        flexShrink: 0,
                                        display: 'inline-block',
                                      }}
                                    />
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: '#495057',
                                        fontSize: '0.825rem',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      {displayText}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{ color: '#adb5bd', fontStyle: 'italic', fontSize: '0.825rem' }}
                                  >
                                    Not Provided
                                  </Typography>
                                )}
                              </Box>

                              {/* Button */}
                              <Box sx={{ flexShrink: 0 }}>
                                {doc.value ? (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<FiDownload />}
                                    href={doc.value}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                      borderColor: '#5BC0BE',
                                      color: '#5BC0BE',
                                      textTransform: 'none',
                                      fontWeight: 600,
                                      borderRadius: 1.5,
                                      fontSize: '0.75rem',
                                      whiteSpace: 'nowrap',
                                      '&:hover': {
                                        borderColor: '#4a9d9b',
                                        bgcolor: 'rgba(91,192,190,0.08)',
                                      },
                                    }}
                                  >
                                    View / Download
                                  </Button>
                                ) : (
                                  <Box sx={{ width: 120 }} />
                                )}
                              </Box>
                            </Box>
                          )
                        })}

                        {/* Array Document Fields */}
                        {[
                          { label: 'General Liability Insurance', value: selectedProvider.generalLiabilityInsuranceDoc },
                          { label: 'Professional Liability Insurance', value: selectedProvider.professionalLiabilityInsuranceDoc },
                          { label: 'Clinical Documents', value: selectedProvider.clinicalDoc },
                        ].map((docArr, groupIdx) => {
                          const hasFiles = docArr.value && docArr.value.length > 0
                          if (hasFiles) {
                            return docArr.value.map((docUrl: string, fileIdx: number) => {
                              const rawName = docUrl
                                ? decodeURIComponent(
                                  docUrl.split('?')[0].split('/').pop() || 'document'
                                )
                                : null
                              const fileName = rawName && rawName.length > 40
                                ? rawName.slice(0, 18) + '…' + rawName.slice(-18)
                                : rawName
                              return (
                                <Box
                                  key={`${groupIdx}-${fileIdx}`}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    py: 1.5,
                                    px: 1,
                                    borderTop: '1px solid #f0f0f0',
                                    '&:hover': { bgcolor: '#fafafa', borderRadius: 1 },
                                  }}
                                >
                                  <Box sx={{ minWidth: 220, flexShrink: 0 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#2c3e50', fontSize: '0.875rem' }}>
                                      {docArr.label} {docArr.value.length > 1 ? `(${fileIdx + 1})` : ''}
                                    </Typography>
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                      <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#5BC0BE', flexShrink: 0, display: 'inline-block' }} />
                                      <Typography variant="body2" sx={{ color: '#495057', fontSize: '0.825rem', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                        {fileName}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box sx={{ flexShrink: 0 }}>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      startIcon={<FiDownload />}
                                      href={docUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      sx={{
                                        borderColor: '#5BC0BE',
                                        color: '#5BC0BE',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderRadius: 1.5,
                                        fontSize: '0.75rem',
                                        whiteSpace: 'nowrap',
                                        '&:hover': { borderColor: '#4a9d9b', bgcolor: 'rgba(91,192,190,0.08)' },
                                      }}
                                    >
                                      View / Download
                                    </Button>
                                  </Box>
                                </Box>
                              )
                            })
                          }
                          return (
                            <Box
                              key={groupIdx}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                py: 1.5,
                                px: 1,
                                borderTop: '1px solid #f0f0f0',
                                '&:hover': { bgcolor: '#fafafa', borderRadius: 1 },
                              }}
                            >
                              <Box sx={{ minWidth: 220, flexShrink: 0 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#2c3e50', fontSize: '0.875rem' }}>
                                  {docArr.label}
                                </Typography>
                              </Box>
                              <Box sx={{ flex: 1, px: 2 }}>
                                <Typography variant="body2" sx={{ color: '#adb5bd', fontStyle: 'italic', fontSize: '0.825rem' }}>
                                  Not Provided
                                </Typography>
                              </Box>
                              <Box sx={{ flexShrink: 0, width: 120 }} />
                            </Box>
                          )
                        })}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>


                {/* {selectedProvider.insuranceAccepted &&
                  selectedProvider.insuranceAccepted.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <HealthAndSafetyIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              Accepted Insurances
                            </Typography>
                          </Box>
                          <Box
                            sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}
                          >
                            {selectedProvider.insuranceAccepted.map(
                              (insurance: any, index: number) => (
                                <Chip
                                  key={index}
                                  label={insurance.name || '--'}
                                  sx={{
                                    bgcolor: '#e3f2fd',
                                    color: '#1976d2',
                                    fontWeight: 600,
                                    border: '1px solid #90caf9',
                                    '&:hover': {
                                      bgcolor: '#bbdefb',
                                    },
                                  }}
                                  size="medium"
                                />
                              )
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <InfoIcon sx={{ color: '#5BC0BE', fontSize: 28 }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Additional Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Bank Connected
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isConnectBank ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isConnectBank
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Subscription Taken
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isSubscriptionTaken
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isSubscriptionTaken
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Service Created
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isServiceCreated ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isServiceCreated
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Slot Added
                          </Typography>
                          <Chip
                            label={selectedProvider.isSlotAdded ? 'Yes' : 'No'}
                            color={
                              selectedProvider.isSlotAdded
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Accepts New Patients
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            HIPAA Signed
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.hasSignedHIPAA ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.hasSignedHIPAA
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Onboarding Date
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.createdAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Last Updated
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.updatedAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}




                {/* Block Reason - at very end of content */}
                {selectedProvider.blockReason && (
                  <Grid item xs={12}>
                    <Alert
                      severity="error"
                      icon={<BlockIcon />}
                      sx={{
                        borderRadius: 2,
                        '& .MuiAlert-message': { width: '100%' },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Block Reason
                      </Typography>
                      <Typography variant="body2">
                        {selectedProvider.blockReason}
                      </Typography>
                    </Alert>
                  </Grid>
                )}


                {selectedProvider.approveComment && (
                  <Grid item xs={12}>
                    <Alert
                      severity="success"
                      icon={<CheckIcon />}
                      sx={{
                        borderRadius: 2,
                        '& .MuiAlert-message': { width: '100%' },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Approve Comments
                      </Typography>
                      <Typography variant="body2">
                        {selectedProvider.approveComment}
                      </Typography>
                    </Alert>
                  </Grid>
                )}



              </Grid>
            </>
          )}
        </DialogContent>
        {selectedProvider && (
          <>
            <Divider sx={{ borderColor: '#e9ecef' }} />
            <DialogActions
              sx={{
                px: 3,
                py: 2.5,
                bgcolor: '#f8f9fa',
                borderTop: '1px solid',
                borderColor: '#e9ecef',
                justifyContent: 'flex-end',
                gap: 1.5,
              }}
            >
              {selectedProvider.status?.toLowerCase() !== 'active' && (
                <Button
                  onClick={handleOpenApproveDialog}
                  variant="contained"
                  color="success"
                  disabled={approveLoading || blockLoading}
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                    },
                  }}
                >
                  {approveLoading ? 'Approving...' : 'Approve Agency'}
                </Button>
              )}
              {selectedProvider.status?.toLowerCase() !== 'blocked' && (
                <Button
                  onClick={handleOpenBlockReasonDialog}
                  variant="contained"
                  color="error"
                  disabled={approveLoading || blockLoading}
                  startIcon={<BlockIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
                    },
                  }}
                >
                  Block Agency
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Approve Comment Dialog */}
      <Dialog
        open={openApproveDialog}
        onClose={handleCloseApproveDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Approve Agency
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: '1rem !important', pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please provide an approval comment for this agency.
          </Typography>
          <TextField
            label="Approval Comment"
            multiline
            rows={4}
            fullWidth
            value={approveComment}
            onChange={e => setApproveComment(e.target.value)}
            placeholder="Enter the approval comment..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            helperText={`${approveComment.length} characters`}
          />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseApproveDialog}
            variant="outlined"
            disabled={approveLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApproveTherapist}
            variant="contained"
            color="success"
            disabled={approveLoading || !approveComment.trim()}
            startIcon={<CheckCircleIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
              },
            }}
          >
            {approveLoading ? 'Approving...' : 'Confirm Approve'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Block Reason Dialog */}
      <Dialog
        open={openBlockReasonDialog}
        onClose={handleCloseBlockReasonDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <BlockIcon sx={{ color: 'error.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Block Agency
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: '1rem !important', pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please provide a reason for blocking this agency. This reason will
            be displayed to the agency in to their account.
          </Typography>
          <TextField
            label="Reason for Blocking"
            multiline
            rows={4}
            fullWidth
            value={blockReason}
            onChange={e => setBlockReason(e.target.value)}
            placeholder="Enter the reason for blocking this agency..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            helperText={`${blockReason.length} characters`}
          />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseBlockReasonDialog}
            variant="outlined"
            disabled={blockLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBlock}
            variant="contained"
            color="error"
            disabled={blockLoading || !blockReason.trim()}
            startIcon={<BlockIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
              },
            }}
          >
            {blockLoading ? 'Blocking...' : 'Confirm Block'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Details Dialog (read-only) */}
      <AgencyDetailsDialog
        open={openProviderDetailsDialog}
        onClose={handleCloseProviderDetailsDialog}
        provider={selectedProviderForDetails}
        onOpenProviderList={handleOpenProviderListModal}
        onOpenUserList={handleOpenUserListModal}
      />
      <TablePopup open={openTablePopup} handleClose={() => setOpenTablePopup(false)} data={tableData} title={tableTitle} />

      {/* Active Providers / Active Users List Dialog */}
      <Dialog
        open={listModalOpen}
        onClose={() => setListModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #3a9e9c 0%, #5BC0BE 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            py: 2,
            px: 3,
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5} sx={{ minWidth: 0, flex: 1, flexWrap: 'wrap' }}>
            <Typography
              variant="h6"
              fontWeight={600}
              fontSize="1.1rem"
              color="inherit"
              sx={{ wordBreak: 'break-word' }}
            >
              {listModalTitle}
            </Typography>
            <Chip
              label={listModalItems.length}
              size="small"
              sx={{ bgcolor: 'rgba(255,255,255,0.25)', color: '#fff', fontWeight: 700, flexShrink: 0 }}
            />
          </Box>
          <Box display="flex" alignItems="center" gap={1} sx={{ flexShrink: 0 }}>
            {listModalItems && listModalItems.length > 0 && (
              <Button
                variant="contained"
                size="small"
                startIcon={exportingListCSV ? <CircularProgress size={14} color="inherit" /> : <DownloadIcon sx={{ fontSize: 16 }} />}
                disabled={exportingListCSV}
                onClick={handleExportListCSV}
                sx={{
                  bgcolor: '#ffffff',
                  color: '#3a9e9c',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  borderRadius: '6px',
                  px: 1.5,
                  py: 0.5,
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.9)',
                    boxShadow: 'none',
                  },
                }}
              >
                {exportingListCSV ? 'Exporting...' : 'Export CSV'}
              </Button>
            )}
            <IconButton
              onClick={() => setListModalOpen(false)}
              sx={{ color: '#fff', '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' } }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3, bgcolor: '#F8FAFC' }}>
          {!listModalItems || listModalItems.length === 0 ? (
            <Box sx={{ py: 6, textAlign: 'center' }}>
              <Typography variant="body1" color="text.secondary" fontWeight={500}>
                No {listModalType === 'provider' ? 'providers' : 'users'} found for this agency.
              </Typography>
            </Box>
          ) : (
            <Stack spacing={2} sx={{ mt: 1 }}>
              {listModalItems.map((item: any, idx: number) => {
                const person = listModalType === 'provider' ? (item?.providerId || item) : item
                const firstName = person?.firstName || ''
                const lastName = person?.lastName || ''
                const name = `${firstName} ${lastName}`.trim() || person?.agencyName || 'N/A'
                const email = person?.email || item?.email || 'N/A'
                const phone = person?.phone || item?.phone || 'N/A'
                const status = item?.status || person?.status || 'active'
                const joinedAt = item?.joinedAt || item?.createdAt || person?.createdAt
                const roleName = person?.role_id?.name || "N/A"
                // console.log("sssssssss",person)

                return (
                  <Paper
                    key={item?._id || person?._id || idx}
                    elevation={0}
                    sx={{
                      p: 2,
                      borderRadius: '12px',
                      border: '1px solid #E2E8F0',
                      bgcolor: '#FFFFFF',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 2,
                      transition: 'all 0.2s',
                      '&:hover': {
                        borderColor: '#CBD5E1',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar
                        sx={{
                          bgcolor: '#e6f7f7',
                          color: '#3a9e9c',
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          width: 44,
                          height: 44,
                        }}
                      >
                        {(firstName.charAt(0) || name.charAt(0) || 'U').toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600} color="#1E293B">
                          {name}
                        </Typography>
                        <Typography variant="caption" display="block" color="#64748B">
                          {email}
                        </Typography>
                        {phone && phone !== 'N/A' && (
                          <Typography variant="caption" display="block" color="#64748B">
                            {phone}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box>
                        {listModalType === 'provider' ? (
                          <>
                            <Typography variant="subtitle2" fontWeight={600} color="#1E293B">
                              Practice Mode
                            </Typography>
                            <Typography variant="caption" display="block" color="#64748B" sx={{ textTransform: 'capitalize' }}>
                              {(() => {
                                const mode = person?.providerWorkWith
                                if (mode === 'independently') return 'Self'
                                if (mode === 'agency') return 'Agency'
                                if (mode === 'both') return 'Self & Agencies'
                                return mode || 'N/A'
                              })()}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography variant="subtitle2" fontWeight={600} color="#1E293B">
                              Title
                            </Typography>
                            <Typography variant="caption" display="block" color="#64748B">
                              {roleName}
                            </Typography>
                          </>
                        )}
                      </Box>
                    </Box>

                    <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.5}>
                      {status && (
                        <Chip
                          label={status}
                          size="small"
                          sx={{
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            textTransform: 'capitalize',
                            height: 22,
                            bgcolor: status === 'active' ? '#DCFCE7' : '#FEE2E2',
                            color: status === 'active' ? '#15803D' : '#B91C1C',
                          }}
                        />
                      )}


                      {joinedAt && (
                        <Typography variant="caption" color="#94A3B8" fontSize="0.7rem">
                          Joined: {dayjs(joinedAt).isValid() ? dayjs(joinedAt).format('MM/DD/YYYY') : String(joinedAt)}
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                )
              })}
            </Stack>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, bgcolor: '#FFFFFF', borderTop: '1px solid #E2E8F0' }}>
          <Button
            onClick={() => setListModalOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              color: '#475569',
              borderColor: '#CBD5E1',
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <AgencyHippaSigningModal
        open={openHippaSignModal}
        agencyId={hippaSignAgencyId}
        onClose={() => setOpenHippaSignModal(false)}
        onSigned={handleHippaSigned}
        getSignUrl={membershipApi.getAgencyHippaSignUrlAdmin}
        confirmSignature={membershipApi.updateAgencyHippaSignatureAdmin}
        subtitle="Version 2.1 (Final) · Confidential — Admin Use Only"
      />
    </div>
  )
}

export default AgencyManagementPage
